import { Header } from "@/components/portfolio/Header";
import { Hero } from "@/components/portfolio/Hero";
import { Marquee } from "@/components/portfolio/Marquee";
import { AboutStrip } from "@/components/portfolio/AboutStrip";
import { Works } from "@/components/portfolio/Works";
import { AllProjects } from "@/components/portfolio/AllProjects";
import { About } from "@/components/portfolio/About";
import { Contact } from "@/components/portfolio/Contact";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F4F4F2] text-[#0A0A0A]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <AboutStrip />
        <Works />
        <AllProjects />
        <About />
        <Contact />
      </main>
    </div>
  );
}
